module.exports = __webpack_public_path__ + "img/duihao1.120e0020.png";